module.exports = __webpack_public_path__ + "img/share_txt.1af8ecbe.png";